import logger from '../../library/Core/logger';
import pageConfig from './PageConfig.json';

const SUPER_ADMIN_PAGE_NAME = 'add-program-super-admin';

const buildSuperAdminConfig = () => {
    const cloned = JSON.parse(JSON.stringify(pageConfig));
    const section = cloned.sectionRepository?.[0];
    const instituteCtrl = section?.controlGroup?.find((c: any) => c.id === 'instituteId');
    if (instituteCtrl) {
        instituteCtrl.type = 'ASYNC_SELECT';
        instituteCtrl.props.domainCategoryCode = 'INSTITUTE_DOMAIN';
        delete instituteCtrl.hideExpression;
    }
    return cloned;
};

class InstituteProgramService {
    static pageLoader(params: any) {
        const state: any = {};
        const { id, pageName } = params;

        return Promise.all([this.getPageConfig(pageName)])
            .then((values) => {
                state.formConfig = values[0];
                state.routeInfo = { id, pageName };
                return Promise.resolve(state);
            })
            .catch(function (err) {
                logger.log(`Error in loading data for ${pageName} and the error is:`);
                console.log(err);
            });
    }

    static getPageConfig(pageName?: string) {
        if (pageName === SUPER_ADMIN_PAGE_NAME) return Promise.resolve(buildSuperAdminConfig());
        return Promise.resolve(pageConfig);
    }
}
export default InstituteProgramService;
